import { cn } from "../../lib/cn";

interface AvatarBubbleProps {
  /** Что отображать: инициалы (имя/email) или иконку (logo). */
  kind: "user" | "ai" | "system";
  label?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

/**
 * Аватар сообщения. Для пользователя — инициалы из имени/email на gradient-фоне.
 * Для AI — фирменный glow-логотип. Для system — нейтральный круг.
 */
export function AvatarBubble({ kind, label, size = "md", className }: AvatarBubbleProps) {
  const sizeMap = {
    sm: "size-7 text-[11px]",
    md: "size-9 text-[12px]",
    lg: "size-11 text-sm",
  };

  if (kind === "user") {
    const initials = (label || "U").trim();
    const short = initials
      .split(/[\s@._-]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((p) => p[0]?.toUpperCase())
      .join("") || "U";
    return (
      <span
        className={cn(
          "inline-flex items-center justify-center rounded-full font-semibold text-white shadow-accent",
          sizeMap[size],
          className,
        )}
        style={{ backgroundImage: "var(--grad-cta)" }}
        aria-hidden
      >
        {short}
      </span>
    );
  }

  if (kind === "ai") {
    return (
      <span
        className={cn(
          "relative inline-flex items-center justify-center rounded-xl text-white shadow-glow",
          sizeMap[size],
          className,
        )}
        style={{ backgroundImage: "var(--grad-cta)" }}
        aria-hidden
      >
        {/* Pulse ring */}
        <span className="absolute inset-0 rounded-xl bg-accent-500/30 animate-pulse-ring" />
        <span className="relative font-bold tracking-tight">AI</span>
      </span>
    );
  }

  // system
  return (
    <span
      className={cn(
        "inline-flex items-center justify-center rounded-full bg-bg-subtle border border-border/60 text-fg-muted",
        sizeMap[size],
        className,
      )}
      aria-hidden
    >
      ·
    </span>
  );
}
